import * as React from 'react';
import { connect } from 'react-redux';
import SVG from 'react-inlinesvg';

import { TooltipCont } from '../../../../infrastructure/tooltips';
import { changeZoom } from '../../../../actions/actions';

const zoomPlus = require('./img/zoom+.svg');
const zoomMinus = require('./img/zoom-.svg');

const mapDispatchToProps = (dispatch: any): any => {
  return {
    handleZoom: (type: string) => {
      dispatch(changeZoom(type));
    },
  };
};

export interface IZoomProps {
  handleZoom?(type: string): void;
}

@(connect(null, mapDispatchToProps) as any)
export default class Zoom extends React.Component<IZoomProps> {
  render() {
    return (

      <div className="result-header-zoom">
        <button onClick={e => this.props.handleZoom!('plus')} title={TooltipCont.ZOOM_PLUS}>
          {<SVG src={zoomPlus}></SVG>}
        </button>
        <button onClick={e => this.props.handleZoom!('minus')} title={TooltipCont.ZOOM_MINUS}>
          {<SVG src={zoomMinus}></SVG>}
        </button>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/common/Zoom.tsx